// app/javascript/controllers/sc_controller.js
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["summary", "current", "hint"];
  static values = { required: Boolean };

  connect() {
    this.form = this.element.closest("form");
    this.updateCurrent();
    this.updateAriaExpanded();

    if (this.form && this.requiredValue) {
      this._onSubmit = this.onFormSubmit.bind(this);
      this.form.addEventListener("submit", this._onSubmit);
    }

    // Si déjà une valeur pré-sélectionnée (back/forward)
    if (this.selectedInput()) {
      this.updateCurrent();
    }
  }

  disconnect() {
    if (this.form && this._onSubmit) {
      this.form.removeEventListener("submit", this._onSubmit);
    }
  }

  // ----- utils -----
  inputs() {
    return this.element.querySelectorAll(".sc-radio");
  }

  selectedInput() {
    return this.element.querySelector(".sc-radio:checked");
  }

  updateCurrent() {
    if (!this.hasCurrentTarget) return;
    const selected = this.selectedInput();
    this.currentTarget.textContent = selected
      ? "1 option sélectionnée"
      : "Aucune sélection";
  }

  hideHint() {
    if (this.requiredValue && this.hasHintTarget) this.hintTarget.style.display = "none";
  }

  showHint() {
    if (this.requiredValue && this.hasHintTarget) this.hintTarget.style.display = "block";
  }

  updateAriaExpanded() {
    if (this.hasSummaryTarget) {
      this.summaryTarget.setAttribute("aria-expanded", this.element.open ? "true" : "false");
    }
  }

  // ----- actions -----
  changed() {
    const selected = this.selectedInput();
    if (selected) {
      selected.setCustomValidity("");
      selected.removeAttribute("aria-invalid");
    }
    this.hideHint();
    this.updateCurrent();
  }

  toggled() {
    this.updateAriaExpanded();
  }

  onFormSubmit(e) {
    if (!this.requiredValue) return;

    if (!this.selectedInput()) {
      e.preventDefault();

      if (!this.element.open) this.element.open = true;

      const first = this.inputs()[0];
      if (first) {
        const label =
          this.element.querySelector(".mc-question, .sc-question")?.textContent?.trim() ||
          "cette question";
        first.setCustomValidity(`Sélectionnez une option pour « ${label} ».`);
        first.setAttribute("aria-invalid", "true");
        first.reportValidity();
        first.focus();
      }

      this.showHint();
      if (this.form?.reportValidity) this.form.reportValidity();
    } else {
      const selected = this.selectedInput();
      if (selected) {
        selected.setCustomValidity("");
        selected.removeAttribute("aria-invalid");
      }
      this.hideHint();
    }
  }
}
